import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, AuthContext } from './context/AuthContext';
import Header from './components/Header';
import InstallPrompt from './components/InstallPrompt';
import DebugLogger from './components/DebugLogger';
import { APP_VERSION } from './version';

// Pages
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import SetupHike from './pages/SetupHike';
import UpdateHike from './pages/UpdateHike';
import HikeReport from './pages/HikeReport';
import TravelCompanion from './pages/TravelCompanion';
import Workbench from './pages/Workbench';

// Styles
import './App.css';

// On-screen debug log panel. Set to true to show it again.
const SHOW_DEBUG_LOGS = false;

// Protected Route Component
function ProtectedRoute({ children }) {
  const { user, loading } = React.useContext(AuthContext);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-xl">Loading...</div>
      </div>
    );
  }

  return user ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App min-h-screen bg-gray-50">
          <Header />
          <InstallPrompt />
          {SHOW_DEBUG_LOGS && <DebugLogger />}
          <main className="container mx-auto px-4 py-8">
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />

              {/* Protected Hiking Routes */}
              <Route
                path="/hike/setup"
                element={
                  <ProtectedRoute>
                    <SetupHike />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/hike/update"
                element={
                  <ProtectedRoute>
                    <UpdateHike />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/hike/report"
                element={
                  <ProtectedRoute>
                    <HikeReport />
                  </ProtectedRoute>
                }
              />

              {/* Travel Companion */}
              <Route
                path="/travel"
                element={
                  <ProtectedRoute>
                    <TravelCompanion />
                  </ProtectedRoute>
                }
              /> 
              
              {/* Hidden workbench — DO NOT link from anywhere */}
              <Route
                path="/bw-c7m4-axe-9k2"
                element={
                  <ProtectedRoute>
                    <Workbench />
                  </ProtectedRoute>
                }
              />

              {/* Catch all */}
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </main>
          <footer className="text-center text-xs text-gray-400 pb-4">
            v{APP_VERSION}
          </footer>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;